import {
  CHOOSE_ADD,
  CHOOSE_ADD_YES,
  CHOOSE_ADD_NO,
  SELECT_ADDRESS_FIELD,
  POSTCODE_LIST_ERROR
} from './addressConstants';
import { isValidGlobalBehaviour, isOptionalGlobalBehaviour } from '../../../utils/validation';

export const resetInternationAddress = (type, formValues) => {
  if (formValues[type] && formValues[type].international) {
    delete formValues[type].international;
  }
  return formValues;
};

export const resetLocalAddress = (type, formValues) => {
  if (formValues[type] && formValues[type].local) {
    delete formValues[type].local;
  }
  return formValues;
};

export const resetChooseAddress = (type, formValues) => {
  let values = formValues;
  values = resetLocalAddress(type, values);
  values = resetInternationAddress(type, values);
  delete values[type][CHOOSE_ADD];
  return values;
};

export const resetSelectAddress = (type, formValues) => {
  return formValues[type] && formValues[type][SELECT_ADDRESS_FIELD]
    ? delete formValues[type][SELECT_ADDRESS_FIELD]
    : formValues;
};

export const resetRequiredFields = (addManuallyClicked, type, formValues) => {
  if (type && formValues) {
    if (checkChooseAddressClick(formValues, type, CHOOSE_ADD_YES)) {
      resetInternationAddress(type, formValues);
      return !addManuallyClicked
        ? resetLocalAddress(type, formValues)
        : resetSelectAddress(type, formValues, addManuallyClicked);
    } else if (checkChooseAddressClick(formValues, type, CHOOSE_ADD_NO)) {
      resetLocalAddress(type, formValues);
      resetSelectAddress(type, formValues, addManuallyClicked);
      // return resetInternationAddress(type, formValues);
    }
    resetUkAddressForm(addManuallyClicked, type, formValues);
  }
};

const resetUkAddressForm = (addManuallyClicked, type, formValues) => {
  if (addManuallyClicked) {
    resetSelectAddress(type, formValues, addManuallyClicked);
  } else if (addManuallyClicked !== undefined) {
    //TODOxCYBG needed for future use resetLocalAddress(type, formValues);
  }
};

export const postCodeFormat = value => {
  let postcode = value;
  postcode = postcode.toUpperCase();
  const postcodeMatch = postcode.match(/^([A-Z]{1,2}\d{1,2}[A-Z]?)\s*(\d[A-Z]{2})$/);
  if (postcodeMatch !== null) {
    postcodeMatch.shift();
    postcode = postcodeMatch.join(' ');
  }
  return postcode;
};

export const isGivenAddress = (formValues, isEdit, type) =>
  formValues && formValues[type] && formValues[type].givenAddress && !isEdit;

export const isRequiredAddressOptional = (value, name) =>
  isOptionalGlobalBehaviour(value, name) ? undefined : 'Required';

export const isRequiredAddress = (
  value,
  name,
  isPostCodeListError,
  postCodeAddressList,
  formValues
) => {
  if (isValidGlobalBehaviour(value, name)) {
    if (isPostCodeListError) {
      return POSTCODE_LIST_ERROR;
    }
    if (
      formValues &&
      formValues.ukAddress &&
      postCodeAddressList &&
      postCodeAddressList.length === 0
    ) {
      return 'Required';
    }
    if (postCodeAddressList && postCodeAddressList.length > 0) {
      return undefined;
    }
    return undefined;
  }
  return 'Required';
};

const checkChooseAddressClick = (formValues, type, condition) =>
  formValues && formValues[type] && formValues[type][CHOOSE_ADD]
    ? formValues[type][CHOOSE_ADD] === condition
    : '';
